import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import {
	DropdownInput,
	CheckboxGroupSerialize
} from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const ExerciseQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		var valid = true;
		if (!props.questionnaire.exerciseFrequentlyHours) {
			valid = false;
		}

		return !valid;
	};
	return (
		<div>
			<div className="form-group mb-2">
				<DropdownInput
					labelText={props.questions.exerciseFrequentlyHours}
					name="exerciseFrequentlyHours"
					value={props.questionnaire.exerciseFrequentlyHours}
					onBlur={props.onQuestionnaireBlur}
					onChange={props.onQuestionnaireChange}
					defaultOption="-"
					options={[
						{
							value: '0',
							text: 'I rarely exercise'
						},
						{
							value: '0-1',
							text: 'Less than 1 hour'
						},
						{
							value: '1-2',
							text: '1-2 hours'
						},
						{
							value: '2-3',
							text: '2-3 hours'
						},
						{
							value: '3-4',
							text: '3-4 hours'
						},
						{
							value: '4-5',
							text: '4-5 hours'
						},
						{
							value: '5-6',
							text: '5-6 hours'
						},
						{
							value: '6-7',
							text: '6-7 hours'
						},
						{
							value: '7+',
							text: 'More than 7 hours'
						}
					]}
				/>
			</div>
			<div className="form-group mb-2">
				<CheckboxGroupSerialize
					title={props.questions.favoriteActivities}
					onUpdate={props.onQuestionnaireChange}
					values={props.questionnaire.favoriteActivities}
					name="favoriteActivities"
					checkOptions={[
						{
							name: 'Aerobics',
							label: 'Aerobics'
						},
						{
							name: 'Baseball or softball',
							label: 'Baseball or softball'
						},
						{
							name: 'Basketball',
							label: 'Basketball'
						},
						{
							name: 'Biking',
							label: 'Biking'
						},
						{
							name: 'Climbing, spelunking, or caving',
							label: 'Climbing, spelunking, or caving'
						},
						{
							name: 'Dancing',
							label: 'Dancing'
						},
						{
							name: 'Equestrian sports',
							label: 'Equestrian sports'
						},
						{
							name: 'Fencing',
							label: 'Fencing'
						},
						{
							name: 'Football',
							label: 'Football'
						},
						{
							name: 'Golfing',
							label: 'Golfing'
						},
						{
							name: 'Gymnastics',
							label: 'Gymnastics'
						},
						{
							name: 'Hiking',
							label: 'Hiking'
						},
						{
							name: 'Hockey',
							label: 'Hockey'
						},
						{
							name: 'Martial arts',
							label: 'Martial arts'
						},
						{
							name: 'Racquet sports',
							label: 'Racquet sports'
						},
						{
							name: 'Rowing',
							label: 'Rowing'
						},
						{
							name: 'Rugby',
							label: 'Rugby'
						},
						{
							name: 'Running, stair climbing, or elliptical machine',
							label: 'Running, stair climbing, or elliptical machine'
						},
						{
							name: 'Skating or rollerblading',
							label: 'Skating or rollerblading'
						},
						{
							name: 'Skiing or snowboarding',
							label: 'Skiing or snowboarding'
						},
						{
							name: 'Soccer',
							label: 'Soccer'
						},
						{
							name: 'Volleyball',
							label: 'Volleyball'
						},
						{
							name: 'Walking',
							label: 'Walking'
						},
						{
							name: 'Water sports',
							label: 'Water sports (e.g., swimming, water polo)'
						},
						{
							name: 'Weightlifting/strength training',
							label: 'Weightlifting/strength training'
						},
						{
							name: 'Wrestling',
							label: 'Wrestling'
						},
						{
							name: 'Yoga',
							label: 'Yoga'
						},
						{
							name: 'Other',
							label: 'Other'
						},
					]}
				/>
			</div>

			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default ExerciseQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/lifestyleQuestions/exerciseQuestion.tsx